<template>
<div class="flex flex-col md:flex-row">
    <a href class="w-full m-1 md:ml-0 p-2 rounded border pointer" @click.prevent="setFrequency('yearly')" :class="isFrequency('yearly') ? 'bg-primary-lighter border border-primary' : 'bg-gray-light border-gray-dark'">
        <div >
            <p class="text-sm font-bold text-center">Yearly <span class="uppercase bg-primary text-white rounded text-xs px-2 py-1">20% OFF</span></p>
            <div class="my-4 text-center">
                <div class="flex items-start justify-center -ml-2">
                    <span class="text-sm text-gray-darker leading-loose">$</span>
                    <span class="text-primary text-4xl font-bold leading-none">
                        {{ yearlyPrice / 12 }} <span class="text-sm font-extralight">/ month</span>
                    </span>
                </div>
                <p class="text-sm">5 seats included</p>
                <p class="text-sm text-gray-darker">+ ${{ yearlyAdditionalPrice / 12 }} per additional seat</p>
            </div>
        </div>
    </a>
    <a href class="w-full m-1 md:ml-0 p-2 rounded border pointer" @click.prevent="setFrequency('monthly')" :class="isFrequency('monthly') ? 'bg-primary-lighter border border-primary' : 'bg-gray-light border-gray-dark'">
        <div>
            <p class="text-sm font-bold text-center">Monthly</p>
            <div class="my-4 text-center">
                <div class="flex items-start justify-center -ml-2">
                    <span class="text-sm text-gray-darker leading-loose">$</span>
                    <span class="text-primary text-4xl font-bold leading-none">
                        {{ monthlyPrice }} <span class="text-sm font-extralight">/ month</span>
                    </span>
                </div>
                <p class="text-sm">5 seats included</p>
                <p class="text-sm text-gray-darker">+ ${{monthlyAdditionalPrice}} per additional seat</p>
            </div>
        </div>
    </a>
</div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        current: {
            type: String,
            required: false, // it'll be null if the user is not a customer yet (i.e. not subscribed to a plan)
        },
        monthlyPrice: {
            type: Number,
            required: false,
        },
        monthlyAdditionalPrice: {
            type: Number,
            required: false,
        },
        yearlyPrice: {
            type: Number,
            required: false,
        },
        yearlyAdditionalPrice: {
            type: Number,
            required: false,
        },
    },
    data() {
        return {
            frequency: undefined,
        }
    },
    mounted() {
        this.frequency = this.currentFrequency || 'yearly';
    },
    computed: {
        currentFragments() {
            if (!this.current) return {};

            const lastIndex = this.current.lastIndexOf('-');
            const id        = this.current.substr(0, lastIndex),
                  frequency = this.current.substr(lastIndex + 1);
            
            return {id, frequency};
        },
        currentId() {
            return this.currentFragments['id'];
        },
        currentFrequency() {
            return this.currentFragments['frequency'];
        },
        isCurrent() {
            return `${this.currentId}.${this.currentFrequency}` === `${this.id}.${this.frequency}`;
        },
    },
    methods: {
        isFrequency(frequency) {
            return this.frequency === frequency;
        },
        setFrequency(frequency) {
            this.frequency = frequency;
            this.pick();
        },
        pick() {
            this.$emit('picked', `${this.id}-${this.frequency}`);
        }
    }
}
</script>